import { isSodimacStandalone, isTottusStandalone } from '@digital-retail/store-manager';
import { CookieStorage } from './CookieStorage';
import _ from './LodashImports';

const groupByBackendCategoryId = ({ products, filterOptions }) => {
  if (!Array.isArray(products)) {
    return [];
  }
  const groupedProducts = products.reduce((acc, variant) => {
    const backendCategoryId = _.get(variant, 'backendCategoryId', '');
    const variantsByGroup = _.get(acc, backendCategoryId, []);
    variantsByGroup.push(variant);
    acc[backendCategoryId] = variantsByGroup;
    return acc;
  }, {});
  const maxGroups = _.get(filterOptions, 'maxGroups');
  const podsByGroup = _.get(filterOptions, 'podsByGroup');
  const selectedVariants = Object.values(groupedProducts)
    .slice(0, maxGroups)
    .flatMap((variants) => variants.slice(0, podsByGroup));
  const minPods = _.get(filterOptions, 'minPods');
  if (!minPods) {
    return selectedVariants;
  }
  if (selectedVariants.length >= minPods) {
    return selectedVariants;
  }
  return [];
};

const getChannel = (appCtx) => {
  const { store } = appCtx || {};
  const channel = isSodimacStandalone(store) ? 'standalone_web' : 'web';
  return channel;
};

const getUserIdFromCookieOrRutHash = (appCtx, rutHash) => {
  const { store, siteConfig } = appCtx || {};
  const shouldSendUserIdToReco = !!siteConfig?.toggles?.shouldSendUserIdToReco;
  if (isTottusStandalone(store)) {
    const userIdFromCookie = shouldSendUserIdToReco ? CookieStorage.getCookie('USER_ID') : '';
    return userIdFromCookie;
  }
  const userIdFromRutHash = shouldSendUserIdToReco ? rutHash : '';
  return userIdFromRutHash;
};

const getContextIdFromCookie = (appCtx) => {
  const { siteConfig } = appCtx || {};
  const shouldSendContextIdToReco = !!siteConfig?.toggles?.shouldSendContextIdToReco;
  const contextId = shouldSendContextIdToReco ? CookieStorage.getCookie('contextID') : '';
  return contextId;
};

const getWidgetsApiParams = ({ appCtx, product, slots, widgetsUUID, userId, contextId, channel, groupId }) => {
  const { zones, regionCode, store, politicalId, priceGroupId } = appCtx || {};
  const { id, currentVariant, attributes, defaultParentCategoryId, brandName, sellerInfo, merchantCategoryId } =
    product || {};
  return {
    productId: id || '',
    zones: zones || '',
    regionCode: regionCode || '',
    channel: channel || getChannel(appCtx),
    site: store || '',
    widgetsUUID: widgetsUUID || '',
    userId: userId || '',
    variantId: currentVariant || '',
    slots: slots || '',
    categoryId: attributes?.GSCCategoryId || '',
    webCategoryId: defaultParentCategoryId || '',
    brandName: brandName || '',
    sellerId: sellerInfo?.sellerId || '',
    contextId: contextId || '',
    politicalId: politicalId || '',
    priceGroupId: priceGroupId || '',
    merchantCategoryId: merchantCategoryId || '',
    groupId: groupId || '',
    pageType: 'PDP',
  };
};

export {
  getChannel,
  getContextIdFromCookie,
  getUserIdFromCookieOrRutHash,
  getWidgetsApiParams,
  groupByBackendCategoryId,
};
